/* Lumaray chrome behaviours: header (mega, search w/ real predictive results,
   sticky condense, announcement ticker, scrim), mobile menu (menu10), and the
   welcome popup (teaser shake / capture / copy). NO cart logic lives here: the
   real cart engine is assets/cart.js (window.LumarayCart), which intercepts
   [data-cart-open]/[data-cart-close] and renders the drawer. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var $ = function (id) { return document.getElementById(id); };
  function money(cents) {
    var n = (cents / 100);
    return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }
  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* =========================================================================
     HEADER
     ========================================================================= */
  try {
    (function () {
      var root = document.querySelector('.hdr10');
      if (!root) return;
      var shell = $('hdr10Shell');
      var header = $('hdr10Header');
      var track = $('hdr10Track');
      var topClose = $('hdr10TopClose');
      var burger = $('hdr10Burger');
      var shopItem = $('hdr10ShopItem');
      var shopTrig = $('hdr10ShopTrigger');
      var searchBtn = $('hdr10SearchBtn');
      var searchForm = $('hdr10SearchForm');
      var searchInp = $('hdr10SearchInput');
      var searchClear = $('hdr10SearchClear');
      var scrim = $('hdr10Scrim');
      var mq = window.matchMedia('(max-width:767.98px)');

      /* ---- announcement ticker (seamless forward loop) ---- */
      if (track && !reduce) {
        var msgs = track.children.length;
        if (msgs > 1) {
          track.appendChild(track.children[0].cloneNode(true));
          var idx = 0, timer;
          var render = function () { track.style.transform = 'translateY(' + (-idx * 52) + 'px)'; };
          var advance = function () {
            idx++;
            track.style.transition = '';
            render();
            if (idx === msgs) {
              setTimeout(function () {
                track.style.transition = 'none';
                idx = 0; render();
                void track.offsetHeight;
                track.style.transition = '';
              }, 580);
            }
          };
          var start = function () { stop(); timer = setInterval(advance, 4400); };
          var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
          start();
          var topBar = root.querySelector('.hdr10-top');
          if (topBar) { topBar.addEventListener('mouseenter', stop); topBar.addEventListener('mouseleave', start); }
        }
      }
      if (topClose) topClose.addEventListener('click', function () { shell.classList.add('top-hidden'); });

      /* ---- sticky condense (hysteresis + rAF) ---- */
      var condensed = false, ticking = false;
      function evalCondense() {
        ticking = false;
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;
        if (!condensed && y > 130) { condensed = true; shell.classList.add('condensed'); }
        else if (condensed && y < 40) { condensed = false; shell.classList.remove('condensed'); }
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(evalCondense); } }, { passive: true });
      evalCondense();

      /* ---- scrim ---- */
      function showScrim(on) { if (scrim) scrim.classList.toggle('show', !!on); }
      function anyPanelOpen() { return header.classList.contains('mega-open') || header.classList.contains('search-open'); }
      function syncScrim() { showScrim(anyPanelOpen()); }
      function isMobile() { return mq.matches; }

      /* ---- MEGA ---- */
      var megaCloseT;
      function openMega() {
        clearTimeout(megaCloseT);
        header.classList.add('mega-open');
        if (shopItem) shopItem.classList.add('open');
        if (shopTrig) shopTrig.setAttribute('aria-expanded', 'true');
        closeSearch();
        syncScrim();
      }
      function closeMega() {
        header.classList.remove('mega-open');
        if (shopItem) shopItem.classList.remove('open');
        if (shopTrig) shopTrig.setAttribute('aria-expanded', 'false');
        syncScrim();
      }
      if (shopItem) shopItem.addEventListener('mouseenter', function () { if (!isMobile()) openMega(); });
      header.addEventListener('mouseenter', function () { clearTimeout(megaCloseT); });
      header.addEventListener('mouseleave', function () { if (!isMobile()) { megaCloseT = setTimeout(closeMega, 220); } });
      root.querySelectorAll('.hdr10-nav > a').forEach(function (a) {
        a.addEventListener('mouseenter', function () { if (!isMobile()) closeMega(); });
      });
      if (shopTrig) shopTrig.addEventListener('click', function (e) {
        e.preventDefault();
        header.classList.contains('mega-open') ? closeMega() : openMega();
      });

      /* ---- SEARCH reveal + real Shopify predictive search ---- */
      var box = $('hdr10SearchResults');
      var statusEl = $('hdr10SearchStatus');
      var debounceT, statusT, lastQ = null, cache = {};

      function srRow(p) {
        var was = (p.compare_at_price && p.compare_at_price > p.price)
          ? '<s><span class="hdr10-vh">Was </span>' + esc(money(p.compare_at_price)) + '</s>' : '';
        var cat = p.type || (p.tags && p.tags[0]) || 'Lumaray';
        return '<a class="hdr10-sr" role="option" href="' + esc(p.url) + '">' +
          '<img src="' + esc(p.image || '') + '" alt="" loading="lazy">' +
          '<span class="hdr10-sr-t">' +
          '<span class="hdr10-sr-c">' + esc(cat) + '</span>' +
          '<b>' + esc(p.title) + '</b>' +
          '<span class="hdr10-sr-p">' + was + '<em><span class="hdr10-vh">Now </span>' + esc(money(p.price)) + '</em></span>' +
          '</span>' +
          '<span class="hdr10-sr-go" aria-hidden="true">&rarr;</span></a>';
      }
      function srGrid(list) { return '<div class="hdr10-sr-grid">' + list.map(srRow).join('') + '</div>'; }

      function paint(q, products) {
        if (!box) return;
        if (searchClear) { if (q) searchClear.removeAttribute('hidden'); else searchClear.setAttribute('hidden', ''); }
        var html;
        if (!q) {
          html = products.length ? '<div class="hdr10-sr-head">Popular products</div>' + srGrid(products) : '';
        } else if (products.length) {
          html = '<div class="hdr10-sr-head">' + products.length + ' result' + (products.length > 1 ? 's' : '') +
            ' for <em>&ldquo;' + esc(q) + '&rdquo;</em></div>' + srGrid(products);
        } else {
          html = '<div class="hdr10-sr-empty">No matches for <b>&ldquo;' + esc(q) + '&rdquo;</b>. Try &ldquo;mask&rdquo;, &ldquo;wand&rdquo; or &ldquo;acne&rdquo;.</div>';
        }
        box.innerHTML = html;
        searchInp.setAttribute('aria-expanded', 'true');
        clearTimeout(statusT);
        statusT = setTimeout(function () {
          if (!statusEl) return;
          statusEl.textContent = !q ? '' : (products.length
            ? products.length + (products.length > 1 ? ' results' : ' result') + ' for ' + q
            : 'No results for ' + q + '.');
        }, 320);
        root.querySelectorAll('.hdr10-suggest [data-q]').forEach(function (a) {
          a.classList.toggle('is-active', !!q && a.getAttribute('data-q') === q);
        });
      }

      function fetchSuggest(q) {
        if (cache[q]) { paint(q, cache[q]); return; }
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            var products = items.map(function (p) {
              return {
                title: p.title,
                url: p.url,
                image: (p.featured_image && (p.featured_image.url || p.image)) || p.image || '',
                price: typeof p.price === 'string' ? Math.round(parseFloat(p.price) * 100) : p.price,
                compare_at_price: p.compare_at_price ? (typeof p.compare_at_price === 'string' ? Math.round(parseFloat(p.compare_at_price) * 100) : p.compare_at_price) : 0,
                type: p.type,
                tags: p.tags
              };
            });
            cache[q] = products;
            if (searchInp.value.trim().toLowerCase() === q) paint(q, products);
          })
          .catch(function () { paint(q, []); });
      }

      function runSearch(raw) {
        var q = (raw || '').trim().toLowerCase();
        if (q === lastQ) return;
        lastQ = q;
        if (!q) { paint('', []); return; }
        clearTimeout(debounceT);
        debounceT = setTimeout(function () { fetchSuggest(q); }, 220);
      }

      function openSearch(open) {
        header.classList.toggle('search-open', open);
        if (searchBtn) searchBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        searchInp.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          closeMega();
          lastQ = null; runSearch(searchInp.value);
          setTimeout(function () { searchInp.focus(); }, 120);
        }
        syncScrim();
      }
      function closeSearch() {
        header.classList.remove('search-open');
        if (searchBtn) searchBtn.setAttribute('aria-expanded', 'false');
        searchInp.setAttribute('aria-expanded', 'false');
      }
      if (searchBtn) searchBtn.addEventListener('click', function () { openSearch(!header.classList.contains('search-open')); });
      if (searchInp) searchInp.addEventListener('input', function () { runSearch(searchInp.value); });
      if (searchClear) searchClear.addEventListener('click', function () { searchInp.value = ''; lastQ = null; runSearch(''); searchInp.focus(); });
      /* submit falls through to the real /search results page (form action=routes.search_url) */
      root.querySelectorAll('.hdr10-suggest [data-q]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          searchInp.value = a.getAttribute('data-q') || a.textContent.trim();
          lastQ = null; runSearch(searchInp.value); searchInp.focus();
        });
      });
      root.addEventListener('click', function (e) { if (e.target.closest('.hdr10-sr')) closeSearch(); });

      /* ---- burger -> open the menu10 drawer ---- */
      if (burger) burger.addEventListener('click', function () {
        if (window.LumarayMenu && window.LumarayMenu.open) window.LumarayMenu.open();
      });

      /* ---- global close ---- */
      if (scrim) scrim.addEventListener('click', function () { closeMega(); closeSearch(); syncScrim(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeMega(); closeSearch(); syncScrim(); }
      });
      mq.addEventListener('change', function () { closeMega(); closeSearch(); syncScrim(); });
    })();
  } catch (e) { console.warn('[chrome] header', e); }

  /* =========================================================================
     MOBILE MENU (menu10)
     ========================================================================= */
  try {
    (function () {
      var screen = $('m10Screen');
      if (!screen) return;
      var closeB = $('m10Close');
      var scrim = $('m10Scrim');
      var drawer = $('m10Drawer');
      var lastFocus = null;

      function openM() {
        lastFocus = document.activeElement;
        screen.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        document.body.classList.add('lr-menu-open'); // slides the CRO teaser to the right, out of the menu
        var burger = $('hdr10Burger'); if (burger) burger.setAttribute('aria-expanded', 'true');
        setTimeout(function () { if (closeB) closeB.focus(); }, 60);
      }
      function shutM() {
        screen.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        document.body.classList.remove('lr-menu-open');
        var burger = $('hdr10Burger'); if (burger) burger.setAttribute('aria-expanded', 'false');
        var sp = $('m10Shop2'); if (sp) { sp.classList.remove('open'); sp.setAttribute('aria-hidden', 'true'); }
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      window.LumarayMenu = { open: openM, close: shutM };

      if (closeB) closeB.addEventListener('click', shutM);
      if (scrim) scrim.addEventListener('click', shutM);

      /* focus trap */
      if (drawer) drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || !screen.classList.contains('is-open')) return;
        var f = drawer.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])');
        var vis = [];
        for (var i = 0; i < f.length; i++) { if (f[i].offsetParent !== null) vis.push(f[i]); }
        if (!vis.length) return;
        var first = vis[0], last = vis[vis.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });

      /* Shop accordion sub-panel */
      var shopToggle = $('m10ShopToggle');
      var shopSub = $('m10ShopSub');
      if (shopToggle && shopSub) {
        shopToggle.addEventListener('click', function () {
          var open = shopSub.classList.toggle('open');
          shopToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
      /* optional level-2 slide panel (kept for parity) */
      var shop2 = $('m10Shop2');
      var shopBack = $('m10ShopBack');
      if (shopBack && shop2) shopBack.addEventListener('click', function () { shop2.classList.remove('open'); shop2.setAttribute('aria-hidden', 'true'); });

      /* inline search toggle */
      var searchBtn = $('m10SearchBtn');
      var searchWrap = $('m10Search');
      var searchInput = $('m10SearchInput');
      if (searchBtn && searchWrap) {
        searchBtn.addEventListener('click', function () {
          var open = searchWrap.classList.toggle('open');
          searchBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open && searchInput) setTimeout(function () { searchInput.focus(); }, 260);
        });
      }

      /* close on menu link nav + Esc */
      drawer.querySelectorAll('.menu10-link[href], .menu10-sublink, .menu10-pcard, .menu10-l2all').forEach(function (a) {
        a.addEventListener('click', function () { setTimeout(shutM, 60); });
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && screen.classList.contains('is-open')) shutM(); });
    })();
  } catch (e) { console.warn('[chrome] menu', e); }

  /* =========================================================================
     WELCOME POPUP (teaser + pop)
     ========================================================================= */
  try {
    (function () {
      var wrap = document.querySelector('[data-welcome]');
      if (!wrap) return;
      var body = document.body;
      var teaser = $('teaser');
      var teaserBtn = $('teaserBtn');
      var pop = $('pop');
      var card = $('popCard');
      var veil = $('veil');
      if (!teaser || !pop) return;

      try { if (localStorage.getItem('lumaray_offer') === 'claimed') { teaser.style.display = 'none'; } } catch (_) {}

      var shakeTimer;
      function shake() {
        // don't shake while the popup or the mobile menu is open (menu-open slides the teaser via transform)
        if (body.classList.contains('pop-open') || body.classList.contains('lr-menu-open') || reduce) return;
        teaser.classList.remove('is-shaking'); void teaser.offsetWidth;
        teaser.classList.add('is-shaking');
      }
      teaser.addEventListener('animationend', function (e) { if (e.animationName === 'teaserShake') teaser.classList.remove('is-shaking'); });
      if (!reduce && teaser.style.display !== 'none') {
        shakeTimer = setInterval(shake, 2800);
        setTimeout(shake, 900);
      }

      var lastFocus = null;
      function openPop() {
        lastFocus = document.activeElement;
        body.classList.add('pop-open');
        pop.setAttribute('aria-hidden', 'false');
        setTimeout(function () { var el = $('popEmail'); if (el) el.focus(); }, 340);
      }
      function closePop() {
        body.classList.remove('pop-open');
        pop.setAttribute('aria-hidden', 'true');
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      teaserBtn.addEventListener('click', openPop);
      var closeBtn = $('popClose'); if (closeBtn) closeBtn.addEventListener('click', closePop);
      var decline = $('popDecline'); if (decline) decline.addEventListener('click', closePop);
      if (veil) veil.addEventListener('click', closePop);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && body.classList.contains('pop-open')) closePop(); });

      var form = $('popForm');
      var email = $('popEmail');
      var errMsg = $('popErr');
      var okEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!okEmail.test((email.value || '').trim())) {
          email.classList.add('err'); if (errMsg) errMsg.classList.add('show'); email.focus(); return;
        }
        email.classList.remove('err'); if (errMsg) errMsg.classList.remove('show');
        card.classList.add('is-done');
        try { localStorage.setItem('lumaray_offer', 'claimed'); } catch (_) {}
        if (shakeTimer) clearInterval(shakeTimer);
      });
      if (email) email.addEventListener('input', function () { email.classList.remove('err'); if (errMsg) errMsg.classList.remove('show'); });

      var copyBtn = $('popCopy');
      if (copyBtn) copyBtn.addEventListener('click', function () {
        var codeEl = $('popCode'); if (!codeEl) return;
        var code = codeEl.textContent.trim(); var b = this;
        try { navigator.clipboard.writeText(code); } catch (_) {}
        b.textContent = 'Copied'; setTimeout(function () { b.textContent = 'Copy'; }, 1800);
      });
      var shopBtn = $('popShop'); if (shopBtn) shopBtn.addEventListener('click', closePop);
    })();
  } catch (e) { console.warn('[chrome] popup', e); }
})();
